// constants
import { BASE_CART_URL, MOBILE_CHECKOUT_URI, COUPONS_URL } from 'shared/constants/uri';

// defs
import { Cart, CartItem } from 'shared/types/cart';
import { CartPageLoadData } from 'shared/layouts/Cart/types';

// helpers
import { getCartPageLoadData } from 'shared/layouts/Cart/helpers';
import NFA from 'shared/helpers/analytics/NFAnalytics';

export const getGrandTotal = (cart?: Cart) => cart?.cartPriceDTO?.grandTotal || 0;

export const getFreeItems = (cart?: Cart) => cart?.freeItems || [];

export const getProducts = (cart?: Cart) => cart?.items || [];

export const getUnSelectedItems = (cart?: Cart) => {
  return cart?.unselectedItems || [];
};

export const getPaymentDetails = (cart?: Cart) => cart?.cartTotal;

export const getCartItemCounts = (cart?: Cart) => cart?.itemCount || 0;

export const getCartItemQuantity = (cart?: Cart) => cart?.quantity || 0;

export const getOOSItems = (cart?: Cart) =>
  [...(cart?.freeItems || []), ...(cart?.freeSamples || []), ...(cart?.items || []), ...(cart?.unselectedItems || [])].filter(
    (item) => item.isOutOfStock
  );

export const getPartialItems = (cart?: Cart) =>
  (cart?.items || []).filter((item) => item.availableQty > 0 && item.availableQty < item.quantity);

export const getOOSItemsForCheckout = (cart?: Cart) =>
  [...(cart?.freeItems || []), ...(cart?.freeSamples || []), ...(cart?.items || [])].filter(
    (item) => item.isOutOfStock
  );

export const getShippingMessage = (cart?: Cart) => cart?.shippingDataDTO?.shippingText;

export const getShippingCommunicationText = (cart?: Cart) =>
  cart?.shippingDataDTO?.communicationText;

export const getCouponCode = (cart?: Cart) => cart?.couponCode;

export const getCouponDiscount = (cart?: Cart) => cart?.cartTotal?.couponDiscount || {};

export const getAddress = (cart?: Cart) => cart?.address;

export const getAddressErrorMessage = (cart?: Cart) => cart?.address?.error?.errorMessage;

export const getCartErrorMessage = (cart?: Cart) => cart?.cartError?.errorMessage;

export const hasErrorMessage = (cart?: Cart) => cart?.cartError?.errorMessage !== undefined;

export const isCartContinueEnabled = (cart?: Cart) => {
  if (cart === undefined) {
    return false;
  }

  if (
    hasErrorMessage(cart) &&
    (cart.cartFlagDTO.isCheckoutAllowed === false || cart.cartFlagDTO.isOrderAllowed === false)
  ) {
    return false;
  }

  return true;
};

export const isAddressContinueEnabled = (cart?: Cart) => cart?.address?.error === undefined;

export const getCartInfoMessage = (cart?: Cart) => cart?.infoMessageDTO?.infoText;

export const getCartAppliedOffersDetails = (cart?: Cart) => cart?.appliedOfferLabelDetails || [];

export const getRewardsDTO = (cart?: Cart) => cart?.rewardsDTO || {};

const SERVICEABILITY_ENABLED_ROUTE = [BASE_CART_URL, MOBILE_CHECKOUT_URI, COUPONS_URL];

export const shouldPincodeToCartRefresh = (pathname: string) =>
  SERVICEABILITY_ENABLED_ROUTE.includes(pathname);

export const updateCartDataOnDatalayer = (cart?: Cart) =>
  NFA.updateDataLayer(getCartPageLoadData(cart as CartPageLoadData));

export const getConvenienceChargesData = (cart?: Cart) =>
  cart?.shippingDataDTO?.convenienceChargesDTO || [];

export const getFomoTag = (cart?: Cart) => cart?.fomoTagDTO || {};

export const getFreeGiftsBannerData = (cart?: Cart) => cart?.freeGiftsBannerData || {};

export const getFreeSamples = (cart?: Cart) => cart?.freeSamples || [];

export const getOOSFreeItems = (cart?: Cart) =>
  [...(cart?.freeItems || []), ...(cart?.freeSamples || [])].filter((item) => item.isOutOfStock);

export const isCartItemOverMaxSaleableQty = (item: CartItem) =>
  !item.isOutOfStock && item.quantity > item.maxSaleableQty;

export const getOverQuantityItems = (cart?: Cart) =>
  (cart?.items || []).filter(isCartItemOverMaxSaleableQty);
